import VueCompositionApi, {
	ref,
	computed,
} from '@vue/composition-api';
import Vue from 'vue';

Vue.use(VueCompositionApi);

const lightboxImages = ref([]);
const currentLightboxImageIndex = ref(null);

export const useLightbox = () => {
	const isLightboxOpen = computed(() => lightboxImages.value.length > 0);

	const isImageGaleryMode = computed(() => lightboxImages.value.length > 1);

	const lastImageIndex = computed(() => lightboxImages.value.length - 1);

	const isLastImage = computed(
		() => currentLightboxImageIndex.value === lightboxImages.value.length - 1,
	);

	const isFirstImage = computed(() => currentLightboxImageIndex.value === 0);

	const currentLightboxImage = computed(
		() => lightboxImages.value[currentLightboxImageIndex.value],
	);

	const setCurrentLightboxImageIndex = (index) => {
		currentLightboxImageIndex.value = index;
	};

	/**
	 * If passed images is not an array wraps the image into array
	 * @param {Object | Array} images
	 */
	const setLightboxImages = (images) => {
		lightboxImages.value = Array.isArray(images) ? images : [images];
	};

	const goToPreviousImage = () => (isFirstImage.value
		? setCurrentLightboxImageIndex(lastImageIndex.value)
		: setCurrentLightboxImageIndex(currentLightboxImageIndex.value - 1));

	const goToNextImage = () => (isLastImage.value
		? setCurrentLightboxImageIndex(0)
		: setCurrentLightboxImageIndex(currentLightboxImageIndex.value + 1));

	const closeLightbox = () => {
		setLightboxImages([]);
		setCurrentLightboxImageIndex(null);
	};

	const onLightboxClickOutside = () => {
		if (!isImageGaleryMode.value) {
			closeLightbox();
		}
	};

	/**
	 * When you add images to lightbox it automatically triggers isLightboxOpen to true
	 * @param {Object | Array} images
	 * @param {Number} [index]
	 */
	const addImagesToLightbox = (images, index = 0) => {
		setLightboxImages(images);
		setCurrentLightboxImageIndex(index);
	};

	const handleLightboxNav = (event) => {
		if (event.key === 'ArrowRight') {
			goToNextImage();
		}

		if (event.code === 'ArrowLeft') {
			goToPreviousImage();
		}

		if (event.code === 'Escape') {
			closeLightbox();
		}
	};

	return {
		lightboxImages: computed(() => lightboxImages.value),
		currentLightboxImageIndex: computed(() => currentLightboxImageIndex.value),
		currentLightboxImage,
		lastImageIndex,
		isFirstImage,
		isLastImage,
		isLightboxOpen,
		isImageGaleryMode,
		setLightboxImages,
		setCurrentLightboxImageIndex,
		goToNextImage,
		goToPreviousImage,
		handleLightboxNav,
		closeLightbox,
		addImagesToLightbox,
		onLightboxClickOutside,
	};
};
